import React, { useState, useEffect } from "react";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { Input } from "../../../../Input/Input";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import { toast } from "react-toastify";

interface UpdateCertiModalProps extends DefaultModalCommonProps {}

export default function UpdateCertiModal({
  closeEvent,
  confirmEvent,
}: UpdateCertiModalProps) {
  const [certiFrom, setCertiFrom] = useState("");
  const [updateCerti, setUpdateCerti] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: updateCerti ? `version/certi` : ``,
    data: {
      certi: Number(certiFrom),
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      toast.success("본인 인증사가 업데이트 되었습니다.");
      if (confirmEvent) confirmEvent();
      closeEvent();
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "본인 인증사 업데이트에 실패하였습니다.");
    }
  }, [error]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="본인 인증 관리"
        isSmallModal={true}
        closeEvent={() => closeEvent()}
        confirmEvent={() => {
          setUpdateCerti(true);
        }}
        confirmDisabled={certiFrom === ""}
        type="input"
      >
        <ModalRow>
          <ModalLabel>본인 인증사</ModalLabel>

          <Input
            type="text"
            inputMode="decimal"
            value={certiFrom}
            onChange={(e) => setCertiFrom(e.target.value)}
            placeholder="숫자를 입력해 주세요. (1: 아임포트, 2:나이스)"
          />
        </ModalRow>
      </DefaultModalLayout>

      {loading && <Loader />}
    </>
  );
}
